import type { AppModule } from '@/config/maintenanceModules';
import { getRouteModule } from '@/utils/maintenanceMode';
import type { RouteLocationNormalized } from 'vue-router';

/** Modules restricted to @capsule / @philips email domains. */
export const CAPSULE_PHILIPS_ONLY_MODULES: AppModule[] = [
    'ps-customer-server',
    'ps-estimate',
    'license-tracker',
    'patient-tile-composer',
];

export function isCapsuleOrPhilipsUser(email: string | undefined): boolean {
    const normalized = (email ?? '').toLowerCase();
    return normalized.includes('@capsule') || normalized.includes('@philips');
}

export function isCapsulePhilipsOnlyModule(module: AppModule): boolean {
    return CAPSULE_PHILIPS_ONLY_MODULES.includes(module);
}

export function isCapsulePhilipsOnlyRoute(to: RouteLocationNormalized): boolean {
    const module = getRouteModule(to);
    return module ? isCapsulePhilipsOnlyModule(module) : false;
}

export function canAccessCapsulePhilipsModule(
    module: AppModule,
    email: string | undefined
): boolean {
    if (!isCapsulePhilipsOnlyModule(module)) {
        return true;
    }
    return isCapsuleOrPhilipsUser(email);
}
